export type ButtonVariant = 'filled' | 'outlined' | 'text';
export type ButtonSizes = 'small' | 'base';

export enum ButtonControlType {
  a = 'a',
  button = 'button',
  link = 'link'
}

export const ButtonControlTypeMap: Record<ButtonControlType, any> = {
  a: 'a',
  button: 'button',
  link: undefined
};

type AllButtonProps = React.ComponentPropsWithRef<'button'> & React.ComponentPropsWithRef<'a'>;
type FinalButtonProps = Omit<AllButtonProps, 'className' | 'style'>;

interface ButtonProps extends FinalButtonProps {
  allowVisited?: boolean;
  isExternalLink?: boolean;
  leadIcon?: React.ReactNode;
  tailIcon?: React.ReactNode;
  variant: ButtonVariant;
  size?: ButtonSizes;
  /** Router specific Link component, required */
  linkComponent: React.ReactNode;
  /** Router specific Link component props, required */
  linkProps: object;
}

export default ButtonProps;
